// extracted by mini-css-extract-plugin
export default {"btnBox":"lbfIvA36JjqFUv8Y0KTA"};